
import styled, {createGlobalStyle} from 'styled-components'
import {Normalize} from 'styled-normalize'

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    background-color: ${props => props.theme.background};
   
    > div.snackbar > h6{
        border-radius: 5px;
    }
    
    > div.snackbar button svg{
        color: ${props => props.theme.background};
        height: .5rem;
        width: .5rem;
    }
`


export const GlobalStyles = createGlobalStyle`
    ${Normalize};
    * ,*:after ,*:before {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html, body, #root {
        width: 100%;
        height: 100%;
        font-size: 100%;
    }

    body {
        font: 16px 'Roboto', Georgia, sans-serif;
        > .toolTip_hidden {
            display: none!important;
        }
        input#queueSwitcher{
            display: none;
        }
        @media screen and (max-width: 680px) {
           
        }
        .select,.form_container {
            &:before,&:after,div:before,div:after  {
                border-bottom-color: ${props => props.theme.primary};
            }
            &::placeholder{
                color: ${props => props.theme.primary};
            }
            &.focus {
                label {
                color: ${props => props.theme.primary};
                }
            }
            &.error {
                label,p {
                    color: ${({theme}) => theme.error}!important;
                }
                .input_border{
                    border-color: ${({theme}) => theme.error}!important;
                }
            }
            .input_border {
                &:hover {
                    color: ${props => props.theme.primary};
                }
            }
            .select_container{
                color: ${props => props.theme.text};
                > svg {
                    fill: ${props => props.theme.primary};
                }
            }
            label {
                margin-left: 6px;
                margin-top: 2px;
                cursor: pointer;
                z-index: 1;
                color: ${props => props.theme.text};
                &[data-shrink="false"] {
                    transform: translate(0 , 10px);
                }
                &+div {
                    min-height: 37px;
                }
            }
        }
        .dialog_container{
            background: ${props => props.theme.bg};
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            >.dialog_content {
                padding: 8px 24px 30px;
            }
            >.dialog_title {
                color: #000000;
                h2 {
                    font-weight: bold;
                    color: inherit;
                    display: flex;
                    button {
                    color: inherit;
                    margin-left: auto;
                        svg {
                            color: ${props => props.theme.text};
                            height: 10px;
                        }
                    }
                }
            }
        }
        
        .select_checkbox {
            padding: 0;
        }
        fieldset.select_input{
            border-color: ${props => props.theme.primary};
            border-radius: 5px;
            
            &.transparent {
                border-color: transparent!important;
                border-radius: 0px;
                &+div {
                    border-radius: 0px;
                }
            }
            &+div {
                border-radius: 5px;
                overflow: hidden;
                em{
                    color: ${props => props.theme.text};
                }
                >div{
                    padding: .7rem 2rem .7rem .875rem!important;
                }
                > svg{
                    right: .5rem;
                    //top: .75rem;
                    color: ${props => props.theme.primary};
                }
            }
        }
    }
`